import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { animate, style, transition, trigger, state } from '@angular/animations';

@Component({
    selector: 'view-transition-splash',
    template: `
    <div class="splash-screen" [@fadeOut]="show ? 'visible' : 'hidden'">
      <div class="splash-content">
        <img src="assets/img/bowtie-white.svg" alt="Tidy" class="bowtie-icon">
        <div class="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  `,
    styles: [`
    .splash-screen {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: black;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .splash-content {
      text-align: center;
    }

    .bowtie-icon {
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
    }

    .loading-dots {
      display: flex;
      justify-content: center;
      gap: 8px;
    }

    .loading-dots span {
      width: 8px;
      height: 8px;
      background-color:rgb(83, 83, 83);
      border-radius: 50%;
      animation: bounce 1.4s infinite ease-in-out;
    }

    .loading-dots span:nth-child(1) { animation-delay: -0.32s; }
    .loading-dots span:nth-child(2) { animation-delay: -0.16s; }

    @keyframes bounce {
      0%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
    }
  `],
    animations: [
        trigger('fadeOut', [
            state('visible', style({ opacity: 1 })),
            state('hidden', style({ opacity: 0 })),
            transition('visible => hidden', [
                animate('300ms ease-in')
            ]),
            transition('hidden => visible', [
                style({ opacity: 0 }),
                animate('0ms')
            ])
        ])
    ],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewTransitionSplashComponent {
  @Input() show = false;
}
